// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

/* 홈으로 돌아가기 링크 */
.back-to-home {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: var(--text-tertiary);
    text-decoration: none;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 24px;
    transition: color var(--transition-fast);
}

.back-to-home:hover {
    color: var(--primary-600);
}

.back-to-home svg {
    width: 18px;
    height: 18px;
    stroke: currentColor;
    stroke-width: 2;
    fill: none;
}

.Login_body {
    font-family: 'Noto Sans KR', 'Outfit', -apple-system, BlinkMacSystemFont, sans-serif;
    min-height: 100vh;
    background: var(--surface);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    margin: 0;
}

/* 메인 컨테이너 */
.login-wrapper {
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: 1400px;
    height: auto;
    min-height: auto;
    background: var(--background);
    overflow: hidden;
    display: grid;
    grid-template-columns: 1.2fr 1fr;
    margin: 0 auto;
    border-radius: 12px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
}

/* ========== 좌측 설명 영역 ========== */
.info-section {
    background: #0f172a;
    padding: 60px 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
}

.brand {
    margin-bottom: 40px;
}

.brand-name {
    font-family: 'Outfit', sans-serif;
    font-size: 32px;
    font-weight: 800;
    color: white;
    letter-spacing: -0.8px;
}

.hero-content {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.hero-title {
    font-family: 'Outfit', sans-serif;
    font-size: 38px;
    font-weight: 800;
    line-height: 1.2;
    color: white;
    margin-bottom: 18px;
    letter-spacing: -1.2px;
}

.hero-description {
    font-size: 16px;
    line-height: 1.6;
    color: rgba(255, 255, 255, 0.85);
    margin-bottom: 40px;
    font-weight: 300;
}

/* 3x2 그리드 레이아웃 */
.features-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    margin-bottom: 40px;
}

.feature-item {
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    padding: 20px;
    transition: background-color var(--transition-fast), border-color var(--transition-fast);
}

.feature-item:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.2);
}

.feature-icon {
    width: 40px;
    height: 40px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 12px;
}

.feature-icon svg {
    width: 22px;
    height: 22px;
    stroke: white;
    fill: none;
}

.feature-title {
    font-size: 15px;
    font-weight: 600;
    color: white;
    margin-bottom: 6px;
    letter-spacing: -0.2px;
}

.feature-description {
    font-size: 13px;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.7);
    font-weight: 300;
}

/* ========== 우측 로그인 영역 ========== */
.login-section {
    background: var(--background);
    padding: 60px 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.login-section > * {
    width: 100%;
    max-width: 400px;
}

.login-header {
    margin-bottom: 35px;
}

.login-title {
    font-family: 'Outfit', sans-serif;
    font-size: 30px;
    font-weight: 700;
    color: var(--text-primary);
    margin-bottom: 8px;
    letter-spacing: -0.8px;
}

.login-subtitle {
    font-size: 15px;
    color: var(--text-tertiary);
    font-weight: 400;
}

.tabs {
    display: flex;
    gap: 4px;
    background: var(--gray-100);
    padding: 4px;
    border-radius: 8px;
    margin-bottom: 28px;
}

.tab {
    flex: 1 1;
    padding: 11px 20px;
    border: none;
    background: transparent;
    color: var(--text-tertiary);
    font-size: 14px;
    font-weight: 600;
    border-radius: 6px;
    cursor: pointer;
    transition: background-color var(--transition-fast), color var(--transition-fast);
    font-family: inherit;
}

.tab.active {
    background: var(--background);
    color: var(--text-primary);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
}

.notice-box {
    background: var(--notice-bg);
    border-left: 3px solid var(--notice-border);
    padding: 14px 18px;
    border-radius: 8px;
    margin-bottom: 28px;
}

.notice-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    font-weight: 600;
    color: var(--notice-title);
    margin-bottom: 5px;
}

.notice-icon {
    width: 16px;
    height: 16px;
}

.notice-text {
    font-size: 12px;
    color: var(--notice-text);
    line-height: 1.5;
}

.form-field {
    margin-bottom: 20px;
}

.field-label {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: var(--text-primary);
    margin-bottom: 8px;
}

.field-label .required {
    color: var(--error);
    margin-left: 2px;
}

.field-input {
    width: 100%;
    padding: 13px 15px;
    border: 1px solid var(--border);
    border-radius: 6px;
    font-size: 14px;
    font-family: inherit;
    transition: border-color var(--transition-fast), box-shadow var(--transition-fast);
    background: var(--background);
}

.field-input:focus {
    outline: none;
    border-color: var(--primary-600);
    box-shadow: var(--focus-ring);
}

.field-input::placeholder {
    color: var(--text-tertiary);
}

.form-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 22px;
}

.checkbox-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
}

.checkbox-wrapper input {
    width: 17px;
    height: 17px;
    cursor: pointer;
    accent-color: var(--primary-600);
}

.checkbox-wrapper label {
    font-size: 13px;
    color: var(--text-secondary);
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
}

.forgot-link {
    font-size: 13px;
    color: var(--primary-600);
    text-decoration: none;
    font-weight: 600;
    transition: color var(--transition-fast);
}

.forgot-link:hover {
    color: var(--primary-700);
}

.submit-button {
    width: 100%;
    padding: 15px;
    background: var(--primary-600);
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color var(--transition-fast);
    font-family: inherit;
}

.submit-button:hover {
    background: var(--primary-700);
}

.submit-button:active {
    transform: translateY(0);
}

.divider {
    display: flex;
    align-items: center;
    gap: 16px;
    margin: 26px 0;
}

.divider-line {
    flex: 1 1;
    height: 1px;
    background: var(--border);
}

.divider-text {
    font-size: 13px;
    color: var(--text-tertiary);
    font-weight: 500;
}

/* ========== 구글 로그인 ========== */
.google-login-wrapper {
    position: relative;
    width: 100%;
    margin-bottom: 20px;
}

.google-login-btn-container {
    display: flex;
    justify-content: center;
    width: 100%;
}

.google-login-loading {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.85);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    font-size: 14px;
    color: var(--text-secondary);
    font-weight: 500;
}

[data-theme="dark"] .google-login-loading {
    background: rgba(30, 30, 30, 0.85);
}

.signup-box {
    background: var(--surface);
    padding: 18px;
    border-radius: 8px;
    text-align: center;
}

.signup-text {
    font-size: 13px;
    color: var(--text-secondary);
    margin-bottom: 14px;
}

.signup-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: var(--primary-600);
    text-decoration: none;
    font-weight: 600;
    font-size: 14px;
    transition: gap var(--transition-fast);
}

.signup-link:hover {
    gap: 10px;
}

.signup-info {
    margin-top: 14px;
    padding-top: 14px;
    border-top: 1px solid var(--border);
    font-size: 12px;
    color: var(--text-tertiary);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
}

.info-icon {
    width: 15px;
    height: 15px;
    stroke: var(--primary-600);
}

/* 비밀번호 토글 */
.password-input-wrapper {
    position: relative;
}

.password-input-wrapper .field-input {
    padding-right: 44px;
}

.password-toggle-btn {
    position: absolute;
    right: 1px;
    top: 1px;
    bottom: 1px;
    width: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    cursor: pointer;
    color: var(--text-tertiary);
    border-radius: 0 6px 6px 0;
    transition: color var(--transition-fast);
}

.password-toggle-btn:hover {
    color: var(--text-secondary);
}

/* 에러 스타일 */
.field-input.error {
    border-color: var(--error);
    box-shadow: 0 0 0 3px var(--error-light);
}

.field-error {
    margin-top: 6px;
    font-size: 12px;
    color: var(--error);
    display: flex;
    align-items: center;
    gap: 4px;
}

.error-alert {
    background: var(--error-alert-bg);
    border: 1px solid var(--error-alert-border);
    border-left: 3px solid var(--error);
    border-radius: 8px;
    padding: 14px 18px;
}

.error-alert-content {
    color: var(--error-alert-text);
    font-size: 13px;
    line-height: 1.5;
}

.error-alert-content strong {
    display: block;
    margin-bottom: 4px;
}

.submit-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none !important;
}

.submit-button.loading {
    position: relative;
    color: transparent;
}

.submit-button.loading::after {
    content: '';
    position: absolute;
    width: 16px;
    height: 16px;
    top: 50%;
    left: 50%;
    margin-left: -8px;
    margin-top: -8px;
    border: 2px solid white;
    border-radius: 50%;
    border-top-color: transparent;
    animation: spin 0.6s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

/* ========== 반응형 ========== */
@media (max-width: 1200px) {
    .login-wrapper {
        max-width: 1200px;
    }

    .hero-title {
        font-size: 34px;
    }

    .features-grid {
        gap: 14px;
    }

    .feature-item {
        padding: 18px;
    }
}

/* ========== Dark Mode ========== */
[data-theme="dark"] .notice-box {
    background: var(--notice-bg);
    border-left-color: var(--notice-border);
}
[data-theme="dark"] .notice-title { color: var(--notice-title); }
[data-theme="dark"] .notice-text { color: var(--notice-text); }
[data-theme="dark"] .error-alert {
    background: var(--error-alert-bg);
    border-color: var(--error-alert-border);
}
[data-theme="dark"] .error-alert-content { color: var(--error-alert-text); }
[data-theme="dark"] .login-wrapper {
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.4);
}

/* ========================================================================
   Login 2026 — 신규 디자인 (Figma: 2025:12153)
   단일 컬럼 중앙 정렬 / 폼 360px / 별 로고 + 슬로건 hero
   ======================================================================== */

.login2026 {
  min-height: 100vh;
  background: #fff;
  font-family: var(--font-sans, 'Pretendard', sans-serif);
  color: var(--fg-text-basic);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 80px 24px 24px;
  box-sizing: border-box;
}

.login2026__main {
  width: 100%;
  max-width: 360px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 32px;
  flex: 1 1;
}

/* ─── Hero — 로고 + 슬로건
   피그마: 텍스트의 왼쪽이 폼의 왼쪽과 일치하고, 로고는 텍스트 왼쪽으로 ~177px 튀어나옴.
   (피그마 좌표: 로고 left=679, 텍스트 left=856, 폼 left=856 → 텍스트와 폼은 정렬, 로고와 텍스트 간격 69px) */
.login2026__hero {
  position: relative;
  width: 100%;
  padding-left: 0;
  text-align: left;
}

.login2026__hero-logo {
  position: absolute;
  left: -177px;
  top: 4px;
  width: 108px;
  height: 120px;
  object-fit: contain;
}

/* 좁은 화면 — 로고가 컬럼 왼쪽 바깥(-177px)으로 나가 잘리므로,
   흐름 안(슬로건 위)으로 되돌려 항상 보이게 한다. */
@media (max-width: 768px) {
  .login2026__hero-logo {
    position: static;
    left: auto;
    top: auto;
    display: block;
    width: 84px;
    height: auto;
    margin: 0 0 16px;
  }
}

.login2026__hero-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin: 0;
  font-size: 40px;
  line-height: 1.15;
  color: var(--fg-text-basic);
}

.login2026__hero-line {
  display: block;
  letter-spacing: -0.5px;
}

.login2026__hero-line--thin    { font-weight: 200; }
.login2026__hero-line--regular { font-weight: 400; }
.login2026__hero-line--bold    { font-weight: 700; }

/* ─── 폼 영역 ─── */
.login2026__form {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.login2026__error {
  padding: 10px 12px;
  background: rgba(231, 76, 60, 0.08);
  border: 1px solid rgba(231, 76, 60, 0.25);
  border-radius: 8px;
  color: var(--fg-anti-red, #e74c3c);
  font-size: 13px;
  line-height: 1.4;
}

.login2026__field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.login2026__field-label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  font-weight: 700;
  color: var(--fg-text-basic);
}

.login2026__input {
  width: 100%;
  box-sizing: border-box;
  padding: 8px 12px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 8px;
  font-family: inherit;
  font-size: 16px;
  line-height: 26px;
  color: var(--fg-text-basic);
  outline: none;
  transition: border-color 160ms ease;
}

.login2026__input::placeholder {
  color: var(--fg-text-gray);
}

.login2026__input:focus,
.login2026__input-wrap:focus-within {
  border-color: var(--fg-button);
}

.login2026__input--inwrap {
  flex: 1 1;
  border: 0;
  padding: 8px 0 8px 12px;
}

.login2026__input--error,
.login2026__input.login2026__input--error {
  border-color: var(--fg-anti-red, #e74c3c);
}

.login2026__input-wrap {
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 8px;
  overflow: hidden;
  transition: border-color 160ms ease;
}

.login2026__eye {
  width: 40px;
  height: 42px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  color: var(--fg-text-gray);
  cursor: pointer;
}

.login2026__eye:hover {
  color: var(--fg-text-basic);
}

.login2026__field-error {
  margin: 0;
  font-size: 12px;
  color: var(--fg-anti-red, #e74c3c);
}

/* ─── 로그인 유지 / 비밀번호 찾기 행 ─── */
.login2026__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 4px;
}

.login2026__check {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.login2026__check input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.login2026__check-box {
  width: 16px;
  height: 16px;
  display: grid;
  place-items: center;
  background: #c2c2c2;
  border-radius: 4px;
  transition: background 160ms ease;
}

.login2026__check-box svg {
  opacity: 0;
}

.login2026__check input:checked + .login2026__check-box {
  background: var(--fg-button);
}

.login2026__check input:checked + .login2026__check-box svg {
  opacity: 1;
}

.login2026__check-text {
  font-size: 14px;
  color: var(--fg-text-basic);
}

.login2026__link {
  background: transparent;
  border: 0;
  padding: 0;
  font-family: inherit;
  font-size: 14px;
  color: var(--fg-link);
  text-decoration: underline;
  text-decoration-style: solid;
  cursor: pointer;
}

.login2026__link:hover {
  color: var(--fg-link-hover);
}

.login2026__link--sm {
  font-size: 12px;
}

/* ─── 로그인 버튼 ─── */
.login2026__submit {
  margin-top: 4px;
  min-height: 44px;
  padding: 12px;
  background: var(--fg-button);
  border: 0;
  border-radius: 8px;
  color: #fff;
  font-family: inherit;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: background 160ms ease;
}

.login2026__submit:hover:not(:disabled) {
  background: var(--fg-button-hover);
}

.login2026__submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* ─── 구분선 (또는) ─── */
.login2026__divider {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 4px;
}

.login2026__divider-line {
  flex: 1 1;
  height: 1px;
  background: var(--fg-line);
}

.login2026__divider-text {
  font-size: 15px;
  color: var(--fg-text-basic);
  line-height: 28px;
}

/* ─── 소셜 로그인 (4종 일체형 라운드 박스) ─── */
.login2026__socials {
  display: flex;
  flex-direction: column;
  background: var(--fg-line);
  border: 1px solid var(--fg-line);
  border-radius: 8px;
  overflow: hidden;
  gap: 1px;
}

.login2026__social {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 44px;
  padding: 8px 12px;
  background: #fff;
  border: 0;
  font-family: inherit;
  font-size: 15px;
  line-height: 28px;
  color: var(--fg-text-basic);
  cursor: pointer;
  transition: background 160ms ease;
}

.login2026__social:hover:not(:disabled) {
  background: #fafafa;
}

.login2026__social:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* GIS 네이티브 버튼 wrapper — 다른 소셜 버튼과 동일한 라인 폭으로 배치 */
.login2026__google-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 44px;
}

/* GIS 가 내부에 div[role="button"] 을 직접 렌더한다. 부모는 가운데 정렬만 담당. */
.login2026__google-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
}

/* 로그인 진행 중 오버레이 표시 */
.login2026__google-loading {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  background: rgba(255, 255, 255, 0.7);
  font-size: 13px;
  color: var(--fg-text-basic, #3b3b3b);
  pointer-events: none;
  border-radius: 4px;
}

/* ─── 가입 안내 + 약관 ─── */
.login2026__signup {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-top: -8px;
}

.login2026__signup-row {
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 15px;
  line-height: 28px;
  color: var(--fg-text-basic);
}

.login2026__terms {
  margin: 0;
  font-size: 12px;
  line-height: 1.6;
  color: var(--fg-text-basic);
  text-align: center;
}

/* ─── 하단 푸터 링크 ─── */
.login2026__footer-links {
  margin-top: 48px;
  padding: 24px 0 16px;
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: center;
  font-size: 12px;
  color: var(--fg-text-basic);
}

.login2026__footer-links a,
.login2026__footer-links span {
  color: inherit;
  text-decoration: none;
  transition: color 160ms ease;
}

.login2026__footer-links a:hover {
  color: var(--fg-link);
}

.login2026__copy {
  color: var(--fg-text-gray);
}

`, "",{"version":3,"sources":["webpack://./src/css/Login.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA,gBAAgB;AAChB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,2BAA2B;IAC3B,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,eAAe;IACf,UAAU;AACd;;AAEA;IACI,oFAAoF;IACpF,iBAAiB;IACjB,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;AACb;;AAEA,YAAY;AACZ;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,6BAA6B;IAC7B,gBAAgB;IAChB,aAAa;IACb,gCAAgC;IAChC,cAAc;IACd,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA,mCAAmC;AACnC;IACI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,0CAA0C;IAC1C,kBAAkB;IAClB,aAAa;IACb,wFAAwF;AAC5F;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;AAC1C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,UAAU;AACd;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA,oCAAoC;AACpC;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,2BAA2B;IAC3B,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iFAAiF;IACjF,oBAAoB;AACxB;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,yCAAyC;AAC7C;;AAEA;IACI,4BAA4B;IAC5B,2CAA2C;IAC3C,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,+BAA+B;IAC/B,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kFAAkF;IAClF,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,mDAAmD;IACnD,oBAAoB;AACxB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA,iCAAiC;AACjC;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,0BAA0B;IAC1B,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,mCAAmC;IACnC,eAAe;IACf,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0BAA0B;AAC9B;;AAEA,YAAY;AACZ;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,WAAW;IACX,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,2BAA2B;IAC3B,0BAA0B;IAC1B,wCAAwC;AAC5C;;AAEA;IACI,4BAA4B;AAChC;;AAEA,WAAW;AACX;IACI,0BAA0B;IAC1B,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,iCAAiC;IACjC,2CAA2C;IAC3C,mCAAmC;IACnC,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,6BAA6B;IAC7B,oCAAoC;AACxC;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA,8BAA8B;AAC9B;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA,oCAAoC;AACpC;IACI,4BAA4B;IAC5B,uCAAuC;AAC3C;AACA,oCAAoC,0BAA0B,EAAE;AAChE,mCAAmC,yBAAyB,EAAE;AAC9D;IACI,iCAAiC;IACjC,uCAAuC;AAC3C;AACA,2CAA2C,8BAA8B,EAAE;AAC3E;IACI,0CAA0C;AAC9C;;AAEA;;;6EAG6E;;AAE7E;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uDAAuD;EACvD,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;EACT,SAAO;AACT;;AAEA;;kFAEkF;AAClF;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;iCACiC;AACjC;EACE;IACE,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,cAAc;IACd,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA,iCAAiC,gBAAgB,EAAE;AACnD,iCAAiC,gBAAgB,EAAE;AACnD,iCAAiC,gBAAgB,EAAE;;AAEnD,iBAAiB;AACjB;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,yCAAyC;EACzC,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,SAAS;EACT,uBAAuB;AACzB;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,kCAAkC;AACpC;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,0BAA0B;EAC1B,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,4BAA4B;EAC5B,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA,4DAA4D;AAC5D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,eAAe;EACf,oCAAoC;EACpC,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;;EAEE,cAAc;EACd,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\n/* 홈으로 돌아가기 링크 */\n.back-to-home {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    color: var(--text-tertiary);\n    text-decoration: none;\n    font-size: 14px;\n    font-weight: 500;\n    margin-bottom: 24px;\n    transition: color var(--transition-fast);\n}\n\n.back-to-home:hover {\n    color: var(--primary-600);\n}\n\n.back-to-home svg {\n    width: 18px;\n    height: 18px;\n    stroke: currentColor;\n    stroke-width: 2;\n    fill: none;\n}\n\n.Login_body {\n    font-family: 'Noto Sans KR', 'Outfit', -apple-system, BlinkMacSystemFont, sans-serif;\n    min-height: 100vh;\n    background: var(--surface);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 40px 20px;\n    margin: 0;\n}\n\n/* 메인 컨테이너 */\n.login-wrapper {\n    position: relative;\n    z-index: 1;\n    width: 100%;\n    max-width: 1400px;\n    height: auto;\n    min-height: auto;\n    background: var(--background);\n    overflow: hidden;\n    display: grid;\n    grid-template-columns: 1.2fr 1fr;\n    margin: 0 auto;\n    border-radius: 12px;\n    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);\n}\n\n/* ========== 좌측 설명 영역 ========== */\n.info-section {\n    background: #0f172a;\n    padding: 60px 50px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    position: relative;\n}\n\n.brand {\n    margin-bottom: 40px;\n}\n\n.brand-name {\n    font-family: 'Outfit', sans-serif;\n    font-size: 32px;\n    font-weight: 800;\n    color: white;\n    letter-spacing: -0.8px;\n}\n\n.hero-content {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.hero-title {\n    font-family: 'Outfit', sans-serif;\n    font-size: 38px;\n    font-weight: 800;\n    line-height: 1.2;\n    color: white;\n    margin-bottom: 18px;\n    letter-spacing: -1.2px;\n}\n\n.hero-description {\n    font-size: 16px;\n    line-height: 1.6;\n    color: rgba(255, 255, 255, 0.85);\n    margin-bottom: 40px;\n    font-weight: 300;\n}\n\n/* 3x2 그리드 레이아웃 */\n.features-grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 16px;\n    margin-bottom: 40px;\n}\n\n.feature-item {\n    background: rgba(255, 255, 255, 0.06);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 8px;\n    padding: 20px;\n    transition: background-color var(--transition-fast), border-color var(--transition-fast);\n}\n\n.feature-item:hover {\n    background: rgba(255, 255, 255, 0.1);\n    border-color: rgba(255, 255, 255, 0.2);\n}\n\n.feature-icon {\n    width: 40px;\n    height: 40px;\n    background: rgba(255, 255, 255, 0.1);\n    border-radius: 6px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 12px;\n}\n\n.feature-icon svg {\n    width: 22px;\n    height: 22px;\n    stroke: white;\n    fill: none;\n}\n\n.feature-title {\n    font-size: 15px;\n    font-weight: 600;\n    color: white;\n    margin-bottom: 6px;\n    letter-spacing: -0.2px;\n}\n\n.feature-description {\n    font-size: 13px;\n    line-height: 1.5;\n    color: rgba(255, 255, 255, 0.7);\n    font-weight: 300;\n}\n\n/* ========== 우측 로그인 영역 ========== */\n.login-section {\n    background: var(--background);\n    padding: 60px 50px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.login-section > * {\n    width: 100%;\n    max-width: 400px;\n}\n\n.login-header {\n    margin-bottom: 35px;\n}\n\n.login-title {\n    font-family: 'Outfit', sans-serif;\n    font-size: 30px;\n    font-weight: 700;\n    color: var(--text-primary);\n    margin-bottom: 8px;\n    letter-spacing: -0.8px;\n}\n\n.login-subtitle {\n    font-size: 15px;\n    color: var(--text-tertiary);\n    font-weight: 400;\n}\n\n.tabs {\n    display: flex;\n    gap: 4px;\n    background: var(--gray-100);\n    padding: 4px;\n    border-radius: 8px;\n    margin-bottom: 28px;\n}\n\n.tab {\n    flex: 1;\n    padding: 11px 20px;\n    border: none;\n    background: transparent;\n    color: var(--text-tertiary);\n    font-size: 14px;\n    font-weight: 600;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: background-color var(--transition-fast), color var(--transition-fast);\n    font-family: inherit;\n}\n\n.tab.active {\n    background: var(--background);\n    color: var(--text-primary);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);\n}\n\n.notice-box {\n    background: var(--notice-bg);\n    border-left: 3px solid var(--notice-border);\n    padding: 14px 18px;\n    border-radius: 8px;\n    margin-bottom: 28px;\n}\n\n.notice-title {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--notice-title);\n    margin-bottom: 5px;\n}\n\n.notice-icon {\n    width: 16px;\n    height: 16px;\n}\n\n.notice-text {\n    font-size: 12px;\n    color: var(--notice-text);\n    line-height: 1.5;\n}\n\n.form-field {\n    margin-bottom: 20px;\n}\n\n.field-label {\n    display: block;\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--text-primary);\n    margin-bottom: 8px;\n}\n\n.field-label .required {\n    color: var(--error);\n    margin-left: 2px;\n}\n\n.field-input {\n    width: 100%;\n    padding: 13px 15px;\n    border: 1px solid var(--border);\n    border-radius: 6px;\n    font-size: 14px;\n    font-family: inherit;\n    transition: border-color var(--transition-fast), box-shadow var(--transition-fast);\n    background: var(--background);\n}\n\n.field-input:focus {\n    outline: none;\n    border-color: var(--primary-600);\n    box-shadow: var(--focus-ring);\n}\n\n.field-input::placeholder {\n    color: var(--text-tertiary);\n}\n\n.form-actions {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 22px;\n}\n\n.checkbox-wrapper {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.checkbox-wrapper input {\n    width: 17px;\n    height: 17px;\n    cursor: pointer;\n    accent-color: var(--primary-600);\n}\n\n.checkbox-wrapper label {\n    font-size: 13px;\n    color: var(--text-secondary);\n    cursor: pointer;\n    user-select: none;\n}\n\n.forgot-link {\n    font-size: 13px;\n    color: var(--primary-600);\n    text-decoration: none;\n    font-weight: 600;\n    transition: color var(--transition-fast);\n}\n\n.forgot-link:hover {\n    color: var(--primary-700);\n}\n\n.submit-button {\n    width: 100%;\n    padding: 15px;\n    background: var(--primary-600);\n    color: white;\n    border: none;\n    border-radius: 6px;\n    font-size: 15px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background-color var(--transition-fast);\n    font-family: inherit;\n}\n\n.submit-button:hover {\n    background: var(--primary-700);\n}\n\n.submit-button:active {\n    transform: translateY(0);\n}\n\n.divider {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    margin: 26px 0;\n}\n\n.divider-line {\n    flex: 1;\n    height: 1px;\n    background: var(--border);\n}\n\n.divider-text {\n    font-size: 13px;\n    color: var(--text-tertiary);\n    font-weight: 500;\n}\n\n/* ========== 구글 로그인 ========== */\n.google-login-wrapper {\n    position: relative;\n    width: 100%;\n    margin-bottom: 20px;\n}\n\n.google-login-btn-container {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n}\n\n.google-login-loading {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(255, 255, 255, 0.85);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 6px;\n    font-size: 14px;\n    color: var(--text-secondary);\n    font-weight: 500;\n}\n\n[data-theme=\"dark\"] .google-login-loading {\n    background: rgba(30, 30, 30, 0.85);\n}\n\n.signup-box {\n    background: var(--surface);\n    padding: 18px;\n    border-radius: 8px;\n    text-align: center;\n}\n\n.signup-text {\n    font-size: 13px;\n    color: var(--text-secondary);\n    margin-bottom: 14px;\n}\n\n.signup-link {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    color: var(--primary-600);\n    text-decoration: none;\n    font-weight: 600;\n    font-size: 14px;\n    transition: gap var(--transition-fast);\n}\n\n.signup-link:hover {\n    gap: 10px;\n}\n\n.signup-info {\n    margin-top: 14px;\n    padding-top: 14px;\n    border-top: 1px solid var(--border);\n    font-size: 12px;\n    color: var(--text-tertiary);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n}\n\n.info-icon {\n    width: 15px;\n    height: 15px;\n    stroke: var(--primary-600);\n}\n\n/* 비밀번호 토글 */\n.password-input-wrapper {\n    position: relative;\n}\n\n.password-input-wrapper .field-input {\n    padding-right: 44px;\n}\n\n.password-toggle-btn {\n    position: absolute;\n    right: 1px;\n    top: 1px;\n    bottom: 1px;\n    width: 42px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    color: var(--text-tertiary);\n    border-radius: 0 6px 6px 0;\n    transition: color var(--transition-fast);\n}\n\n.password-toggle-btn:hover {\n    color: var(--text-secondary);\n}\n\n/* 에러 스타일 */\n.field-input.error {\n    border-color: var(--error);\n    box-shadow: 0 0 0 3px var(--error-light);\n}\n\n.field-error {\n    margin-top: 6px;\n    font-size: 12px;\n    color: var(--error);\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.error-alert {\n    background: var(--error-alert-bg);\n    border: 1px solid var(--error-alert-border);\n    border-left: 3px solid var(--error);\n    border-radius: 8px;\n    padding: 14px 18px;\n}\n\n.error-alert-content {\n    color: var(--error-alert-text);\n    font-size: 13px;\n    line-height: 1.5;\n}\n\n.error-alert-content strong {\n    display: block;\n    margin-bottom: 4px;\n}\n\n.submit-button:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n    transform: none !important;\n}\n\n.submit-button.loading {\n    position: relative;\n    color: transparent;\n}\n\n.submit-button.loading::after {\n    content: '';\n    position: absolute;\n    width: 16px;\n    height: 16px;\n    top: 50%;\n    left: 50%;\n    margin-left: -8px;\n    margin-top: -8px;\n    border: 2px solid white;\n    border-radius: 50%;\n    border-top-color: transparent;\n    animation: spin 0.6s linear infinite;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n/* ========== 반응형 ========== */\n@media (max-width: 1200px) {\n    .login-wrapper {\n        max-width: 1200px;\n    }\n\n    .hero-title {\n        font-size: 34px;\n    }\n\n    .features-grid {\n        gap: 14px;\n    }\n\n    .feature-item {\n        padding: 18px;\n    }\n}\n\n/* ========== Dark Mode ========== */\n[data-theme=\"dark\"] .notice-box {\n    background: var(--notice-bg);\n    border-left-color: var(--notice-border);\n}\n[data-theme=\"dark\"] .notice-title { color: var(--notice-title); }\n[data-theme=\"dark\"] .notice-text { color: var(--notice-text); }\n[data-theme=\"dark\"] .error-alert {\n    background: var(--error-alert-bg);\n    border-color: var(--error-alert-border);\n}\n[data-theme=\"dark\"] .error-alert-content { color: var(--error-alert-text); }\n[data-theme=\"dark\"] .login-wrapper {\n    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.4);\n}\n\n/* ========================================================================\n   Login 2026 — 신규 디자인 (Figma: 2025:12153)\n   단일 컬럼 중앙 정렬 / 폼 360px / 별 로고 + 슬로건 hero\n   ======================================================================== */\n\n.login2026 {\n  min-height: 100vh;\n  background: #fff;\n  font-family: var(--font-sans, 'Pretendard', sans-serif);\n  color: var(--fg-text-basic);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 80px 24px 24px;\n  box-sizing: border-box;\n}\n\n.login2026__main {\n  width: 100%;\n  max-width: 360px;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 32px;\n  flex: 1;\n}\n\n/* ─── Hero — 로고 + 슬로건\n   피그마: 텍스트의 왼쪽이 폼의 왼쪽과 일치하고, 로고는 텍스트 왼쪽으로 ~177px 튀어나옴.\n   (피그마 좌표: 로고 left=679, 텍스트 left=856, 폼 left=856 → 텍스트와 폼은 정렬, 로고와 텍스트 간격 69px) */\n.login2026__hero {\n  position: relative;\n  width: 100%;\n  padding-left: 0;\n  text-align: left;\n}\n\n.login2026__hero-logo {\n  position: absolute;\n  left: -177px;\n  top: 4px;\n  width: 108px;\n  height: 120px;\n  object-fit: contain;\n}\n\n/* 좁은 화면 — 로고가 컬럼 왼쪽 바깥(-177px)으로 나가 잘리므로,\n   흐름 안(슬로건 위)으로 되돌려 항상 보이게 한다. */\n@media (max-width: 768px) {\n  .login2026__hero-logo {\n    position: static;\n    left: auto;\n    top: auto;\n    display: block;\n    width: 84px;\n    height: auto;\n    margin: 0 0 16px;\n  }\n}\n\n.login2026__hero-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  margin: 0;\n  font-size: 40px;\n  line-height: 1.15;\n  color: var(--fg-text-basic);\n}\n\n.login2026__hero-line {\n  display: block;\n  letter-spacing: -0.5px;\n}\n\n.login2026__hero-line--thin    { font-weight: 200; }\n.login2026__hero-line--regular { font-weight: 400; }\n.login2026__hero-line--bold    { font-weight: 700; }\n\n/* ─── 폼 영역 ─── */\n.login2026__form {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.login2026__error {\n  padding: 10px 12px;\n  background: rgba(231, 76, 60, 0.08);\n  border: 1px solid rgba(231, 76, 60, 0.25);\n  border-radius: 8px;\n  color: var(--fg-anti-red, #e74c3c);\n  font-size: 13px;\n  line-height: 1.4;\n}\n\n.login2026__field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.login2026__field-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--fg-text-basic);\n}\n\n.login2026__input {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 8px 12px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 16px;\n  line-height: 26px;\n  color: var(--fg-text-basic);\n  outline: none;\n  transition: border-color 160ms ease;\n}\n\n.login2026__input::placeholder {\n  color: var(--fg-text-gray);\n}\n\n.login2026__input:focus,\n.login2026__input-wrap:focus-within {\n  border-color: var(--fg-button);\n}\n\n.login2026__input--inwrap {\n  flex: 1;\n  border: 0;\n  padding: 8px 0 8px 12px;\n}\n\n.login2026__input--error,\n.login2026__input.login2026__input--error {\n  border-color: var(--fg-anti-red, #e74c3c);\n}\n\n.login2026__input-wrap {\n  display: flex;\n  align-items: center;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n  overflow: hidden;\n  transition: border-color 160ms ease;\n}\n\n.login2026__eye {\n  width: 40px;\n  height: 42px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  color: var(--fg-text-gray);\n  cursor: pointer;\n}\n\n.login2026__eye:hover {\n  color: var(--fg-text-basic);\n}\n\n.login2026__field-error {\n  margin: 0;\n  font-size: 12px;\n  color: var(--fg-anti-red, #e74c3c);\n}\n\n/* ─── 로그인 유지 / 비밀번호 찾기 행 ─── */\n.login2026__row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 4px;\n}\n\n.login2026__check {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.login2026__check input {\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.login2026__check-box {\n  width: 16px;\n  height: 16px;\n  display: grid;\n  place-items: center;\n  background: #c2c2c2;\n  border-radius: 4px;\n  transition: background 160ms ease;\n}\n\n.login2026__check-box svg {\n  opacity: 0;\n}\n\n.login2026__check input:checked + .login2026__check-box {\n  background: var(--fg-button);\n}\n\n.login2026__check input:checked + .login2026__check-box svg {\n  opacity: 1;\n}\n\n.login2026__check-text {\n  font-size: 14px;\n  color: var(--fg-text-basic);\n}\n\n.login2026__link {\n  background: transparent;\n  border: 0;\n  padding: 0;\n  font-family: inherit;\n  font-size: 14px;\n  color: var(--fg-link);\n  text-decoration: underline;\n  text-decoration-style: solid;\n  cursor: pointer;\n}\n\n.login2026__link:hover {\n  color: var(--fg-link-hover);\n}\n\n.login2026__link--sm {\n  font-size: 12px;\n}\n\n/* ─── 로그인 버튼 ─── */\n.login2026__submit {\n  margin-top: 4px;\n  min-height: 44px;\n  padding: 12px;\n  background: var(--fg-button);\n  border: 0;\n  border-radius: 8px;\n  color: #fff;\n  font-family: inherit;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 160ms ease;\n}\n\n.login2026__submit:hover:not(:disabled) {\n  background: var(--fg-button-hover);\n}\n\n.login2026__submit:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* ─── 구분선 (또는) ─── */\n.login2026__divider {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 4px;\n}\n\n.login2026__divider-line {\n  flex: 1;\n  height: 1px;\n  background: var(--fg-line);\n}\n\n.login2026__divider-text {\n  font-size: 15px;\n  color: var(--fg-text-basic);\n  line-height: 28px;\n}\n\n/* ─── 소셜 로그인 (4종 일체형 라운드 박스) ─── */\n.login2026__socials {\n  display: flex;\n  flex-direction: column;\n  background: var(--fg-line);\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n  overflow: hidden;\n  gap: 1px;\n}\n\n.login2026__social {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 44px;\n  padding: 8px 12px;\n  background: #fff;\n  border: 0;\n  font-family: inherit;\n  font-size: 15px;\n  line-height: 28px;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  transition: background 160ms ease;\n}\n\n.login2026__social:hover:not(:disabled) {\n  background: #fafafa;\n}\n\n.login2026__social:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* GIS 네이티브 버튼 wrapper — 다른 소셜 버튼과 동일한 라인 폭으로 배치 */\n.login2026__google-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  min-height: 44px;\n}\n\n/* GIS 가 내부에 div[role=\"button\"] 을 직접 렌더한다. 부모는 가운데 정렬만 담당. */\n.login2026__google-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 44px;\n}\n\n/* 로그인 진행 중 오버레이 표시 */\n.login2026__google-loading {\n  position: absolute;\n  inset: 0;\n  display: grid;\n  place-items: center;\n  background: rgba(255, 255, 255, 0.7);\n  font-size: 13px;\n  color: var(--fg-text-basic, #3b3b3b);\n  pointer-events: none;\n  border-radius: 4px;\n}\n\n/* ─── 가입 안내 + 약관 ─── */\n.login2026__signup {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  margin-top: -8px;\n}\n\n.login2026__signup-row {\n  margin: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 15px;\n  line-height: 28px;\n  color: var(--fg-text-basic);\n}\n\n.login2026__terms {\n  margin: 0;\n  font-size: 12px;\n  line-height: 1.6;\n  color: var(--fg-text-basic);\n  text-align: center;\n}\n\n/* ─── 하단 푸터 링크 ─── */\n.login2026__footer-links {\n  margin-top: 48px;\n  padding: 24px 0 16px;\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  flex-wrap: wrap;\n  justify-content: center;\n  font-size: 12px;\n  color: var(--fg-text-basic);\n}\n\n.login2026__footer-links a,\n.login2026__footer-links span {\n  color: inherit;\n  text-decoration: none;\n  transition: color 160ms ease;\n}\n\n.login2026__footer-links a:hover {\n  color: var(--fg-link);\n}\n\n.login2026__copy {\n  color: var(--fg-text-gray);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
